// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"styles_closeButton__3lMpq","dialog":"styles_dialog__D7PI7","scrollBody":"styles_scrollBody__wc997"};